import * as JSCookie from 'js-cookie';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import UserDucks from 'stores/ducks/User.duck';

class LogoutPage extends Component<{ dispatch?: any }> {
	public componentDidMount() {
		JSCookie.remove('user');
		JSCookie.remove('token');
		this.props.dispatch(
			UserDucks.setUser({
				id: '',
				name: '',
				lastname: '',
				username: '',
				token: '',
				stripeId: '',
				email: '',
				isAdmin: false,
				lastLoginAt: new Date()
			}),
		);
	}

	public render() {
		return <Redirect to='/login' />;
	}
}

export default connect(state => {
	return {
		token: UserDucks.getToken(state),
	};
})(LogoutPage);



// WEBPACK FOOTER //
// ./src/pages/auth/logout/Logout.page.tsx